import axiosInstance from "../axiosInstance";
import ApiRequest from "../axiosInstance/request";
import { endpoints } from "../endpoints";

export const signUpMutation = async (body) => {
  try {
    const res = await ApiRequest.post(endpoints.auth.signup, body);

    return res;
  } catch (error) {
    return error;
  }
};

export const ProfileUpdateMutation = async (body) => {
  try {
    const res = await ApiRequest.post(endpoints.auth.userUpdate, body);

    return res;
  } catch (error) {
    return error;
  }
};

export const GetprofileData = async (params) => {
  try {
    const res = await ApiRequest.get(
      `${endpoints.auth.userdeatils}?user_id=${params?.id}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const topAcquisitorsList = () => {
  return new Promise((resolve, reject) => {
    ApiRequest.get(`${endpoints.cms.getUser}?top_partner=yes`)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const PendingInvitationsList = (pageParam) => {
  return new Promise((resolve, reject) => {
    ApiRequest.get(
      `${endpoints.cms.getUser}?pending_invitation=yes&page=${pageParam}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const totaluserList = (params) => {
  const { page, sort } = params ?? {};
  return new Promise((resolve, reject) => {
    ApiRequest.get(
      `${endpoints.auth.HubuserList}?page=${page} ${
        !!sort ? `&order_asc=${params?.sort}` : ""
      }`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const totaluserListstatusChangeMutation = async (body) => {
  try {
    const res = await ApiRequest.post(
      endpoints.auth.HubuserListStatusUpdate,
      body
    );

    return res;
  } catch (error) {
    return error;
  }
};

export const expensesBreakdownList = (body, payload) => {
  return new Promise((resolve, reject) => {
    ApiRequest.post(endpoints.cms.expensesBreakdown, { ...body, ...payload })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const customTopAcquisitorsList = (queryParams, pageParam) => {
  const { startDate: from, endDate: to } = queryParams;
  return new Promise((resolve, reject) => {
    ApiRequest.get(
      `${endpoints.cms.getUser}?top_partner=yes${
        from && to ? `&from=${from}&to=${to}` : ""
      }&page=${pageParam}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const roleWiseExpense = (body, payload) => {
  console.warn("🚀 ~ file: cms.api.js:24 ~ submissionsList ~ body:", body);
  return new Promise((resolve, reject) => {
    ApiRequest.post(endpoints.cms.roleWiseExpense, body)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const searchDataCall = (query, pageParam) => {
  console.warn("🚀 ~ file: cms.api.js:24 ~ submissionsList ~ body:", query);
  return new Promise((resolve, reject) => {
    ApiRequest.post(
      `${endpoints.videos.videos}?search=${query}&page=${pageParam}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
